module.exports = __webpack_public_path__ + "static/media/HOW TO CREATE PIPELINES AND DEALS IN EZYMIGRATE SYSTEM.97555c64.png";